import React, { useEffect } from "react";
import { DocumentHeader } from "./document-header/documentHeader";
import { DocumentItem } from "./document-item/documentItem";
import { useDocumentContext } from "../Documents";

export const DocumentTable = ({ docData ,selectedFiles, setSelectedFiles, uploadedList, showHeaderBtn = false,selectedChat }) => {
  const documentContext = useDocumentContext();

  return (
    <>
      <div className="bg-bgGreen px-2.5 py-1.5 flex justify-between">
        <p className="text-lg text-white font-normal">Documents</p>
        {showHeaderBtn && (
        <div className="flex gap-2">
          <button type="button" disabled={!documentContext?.isAnyDocumentSelected()} className={`py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border bg-gray-50  hover:bg-gray-e5 hover:text-black-300 ${!documentContext?.isAnyDocumentSelected() && "opacity-50 cursor-not-allowed"}`} onClick={()=>documentContext?.linkResultWithNote('', false, true)}>Add to Note</button>
          <button type="button" disabled={!documentContext?.isAnyDocumentSelected()} className={`py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border bg-gray-50  hover:bg-gray-e5 hover:text-black-300 ${!documentContext?.isAnyDocumentSelected() && "opacity-50 cursor-not-allowed"}`} onClick={()=>documentContext?.linkResultWithNote('', true, true)}>Remove from Note</button>
          <button type="button" disabled={!documentContext?.isAnyDocumentSelected()} className={`py-1 px-2.5 font-normal rounded text-[14px] text-black-300 border-gray-c3 border bg-gray-50  hover:bg-gray-e5 hover:text-black-300 ${!documentContext?.isAnyDocumentSelected() && "opacity-50 cursor-not-allowed"}`} onClick={()=>documentContext?.shareDoc()}>Share</button>
        </div>
        )}
      </div>
      <div className="transition duration-300 ease-in-out">
        <div className="box-shadow">
          <table className="divide-y divide-gray-300 w-full">
            <DocumentHeader document={docData} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} uploadedList={uploadedList} />
            <tbody className="divide-y divide-gray-200 bg-white alternative-color">
              {docData?.map((document) => (
                <DocumentItem  selectedChat={selectedChat} key={document.id} document={document} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} uploadedList={uploadedList} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
